var app = require('../index');

//TODO should these be moved to songs.js and renamed?

//Search Results

//Commenting - this event takes too long to get bound
//app.fn('searchResults.selectAll', function(e, el) {
//	jQuery('.song-checkbox').prop('checked', el.checked);
//});

app.fn('searchResults.viewSongDetail', function(e, el) {
	if (jQuery('.song-checkbox:checked').length) {
		var msg = 'You have one or more songs selected. If you proceed to view the details for this song, you will lose your selection. '+
			'Click OK to discard your selection and continue.'
		if (!confirm(msg))
			e.preventDefault();
	}
});

app.fn('searchResults.showRemainingSearchParams', function(e, el) {
	this.model.set('_page.showRemainingSearchParams', true);
});

app.fn('searchResults.recentlyAddedDaysChange', function(e, el) {
	var numDaysAgo = e.get('_page.search.dateShowCreated.numDays');
	log(numDaysAgo);
});